import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import _ from 'lodash'
import googleMapStyles from '@/assets/map.json'
import { uuid } from 'vue-uuid'
import VueCookies from 'vue-cookies'


Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
VueCookies.config('2min')

const key = (window).envConfig && (window).envConfig.NAC_APIM_KEY ? (window).envConfig.NAC_APIM_KEY : 'NAC_APIM_KEY';

let apiServer = Vue.axios.create({
  baseURL: (window).envConfig && (window).envConfig.JLL_CALC_API_URL ? (window).envConfig.JLL_CALC_API_URL : 'http://localhost:5000/api/v1',
  timeout: 10000,
  headers: { 
    'Subscription-Key': key
  }
})

apiServer.interceptors.request.use((config) => {
  const tokens = localStorage.getItem('okta-token-storage');
  const obj = JSON.parse(tokens);
  const tokenData = obj && obj.accessToken && obj.accessToken.accessToken || null;
  
  if (tokenData) {
    config.headers.Authorization = `Bearer ${tokenData}`;
  }
  
  return config;
});

let pdfMapStyleParams = ""
googleMapStyles.forEach(style => {
  pdfMapStyleParams += "&style="
  
  if(style.featureType) {
    pdfMapStyleParams += "feature:" + style.featureType + "|"
  }
  
  if(style.elementType) {
    pdfMapStyleParams += "element:" + style.elementType + "|"
  }
  
  style.stylers.forEach( (styler, index) => {
    Object.keys(styler).forEach( stylerKey => {
      let k = stylerKey
      let v = styler[stylerKey]
      
      if(k == "color"){
        v = v.replace("#","0x")
      }
      
      pdfMapStyleParams += (index != 0 ? "|" : "") + k + ":" + v
    })
  })
})

export default new Vuex.Store({
  state: {
    apiServer: apiServer,
    sessionId: '',
    accessingUserInfo: {
      userSub: '',
      userEmail: '',
      userName: '',
      userIp: '',
      userBrowser: '',
      userOs: ''
    },
    markets: [],

    availableMarkets: [],
    defaultMarkets: [],
    customers: [],
    marketToCustomerLinks: [],

    serverRequestInProcessSemaphore: 0,

    defaults: {
      annualRevenue: 100000000,
      distributionCenterCount: 4,
      totalSquareFootage: 78212,
      assumptions: {
        freight: {
          percentageLocked: true,
          percentageOfRevenue: 4.0,
          inboundCost: 1333320,
          outboundCost: 3066400
        },
        inventory: {
          percentageLocked: true,
          percentageOfRevenue: 11.0,
          totalHoldings: 11000000,
          costOfCapital: 8,
          shrinkObsolescence: 10
        },
        labor: {
          hourlyRate: 15.02,
          totalNetworkEmployees: 33
        },
        lease: {
          ratePerSqft: 6.3924
        }
      }
    },

    annualRevenue: 100000000,
    distributionCenterCount: 4,
    totalSquareFootage: 78212,

    inputAdjusters: {
      leaseCostFactor: 1.0,
      distributionCenterCountFactor: 0,
      laborCostFactor: 1.0,
      networkAnalysisBaseServiceRanges: {}
    },

    assumptions: {
      freight: {
        percentageLocked: true,
        percentageOfRevenue: 4.0,
        inboundCost: 1333320,
        outboundCost: 3066400
      },
      inventory: {
        percentageLocked: true,
        percentageOfRevenue: 11.0,
        totalHoldings: 11000000,
        costOfCapital: 8,
        shrinkObsolescence: 10
      },
      labor: {
        rateAverageLocked: true,
        hourlyRate: 16.08,
        totalNetworkEmployees: 33
      },
      lease: {
        rateAverageLocked: true,
        ratePerSqft: 5.2226
      }
    },

    networkAnalysisCosts: {
      freightCost: 0,
      inboundFreightCost: 0,
      outboundFreightCost: 0,
      inventoryCost: 0,
      realEstateCost: 0,
      laborCost: 0,
      totalCost: 0
    },

    networkAnalysisServiceRanges: {
      bins: [
        { name: "1 Day",  serviceRangeValue: 33 },
        { name: "2 Day",  serviceRangeValue: 50 },
        { name: "3+ Days", serviceRangeValue: 17 }
      ]
    },

    marketsToCompare: [],
    marketCostComparison: [],
    marketParams: {},
    customMarkets: [],
    customMarketGeocodedData: {},
    naMarketManuallySpecified: false,
    
    sessionUsageData: {},
    incompleteSessionSurveyShown: false,
    pdfMapStyleParams: pdfMapStyleParams
  },

  mutations: {
    setMarkets(state, markets) {
      state.markets = markets
      this.commit('setDistributionCenterCount', markets.length)
      this.dispatch('getNetworkAnalysisCosts')
      this.dispatch('getNetworkAnalysisServiceRanges')
      this.dispatch('getMarketToCustomerLinks')
    },
    setDefaultMarkets(state, markets) {
      state.defaultMarkets = markets
    },
    setCustomers(state, customers) {
      state.customers = customers
    },
    setAvailableMarkets(state, markets) {
      state.availableMarkets = markets
    },
    setMarketParams(state, marketParams) {
      state.marketParams = marketParams
    },
    setCustomMarkets(state, customMarkets) {
      state.customMarkets = customMarkets
    },
    setNaMarketManuallySpecified(state, v) {
      state.naMarketManuallySpecified = v
    },
    setAnnualRevenue(state, v) {
      state.annualRevenue = v

      // update inventory calcs
      if(state.assumptions.inventory.percentageLocked) {
        state.assumptions.inventory.totalHoldings = Number((state.annualRevenue * (state.assumptions.inventory.percentageOfRevenue / 100)).toFixed(0))
      }

      // update freight calcs
      if(state.assumptions.freight.percentageLocked) {
        let inboundPercentOfTrans = 0.33333, outboundPercentOfTrans = 0.8666 - (0.05 * Math.pow(state.distributionCenterCount, 0.5))
  
        state.assumptions.freight.inboundCost  = Number((inboundPercentOfTrans * (state.annualRevenue * (state.assumptions.freight.percentageOfRevenue / 100))).toFixed(0))
        state.assumptions.freight.outboundCost = Number((outboundPercentOfTrans * (state.annualRevenue * (state.assumptions.freight.percentageOfRevenue / 100))).toFixed(0))
      }

      this.dispatch('getNetworkAnalysisCosts')
    },
    setDistributionCenterCount(state, v) {
      state.distributionCenterCount = v
    },
    setNetworkAnalysisCosts(state, v) {
      state.networkAnalysisCosts = v
    },
    setNetworkAnalysisServiceRanges(state, v) {
      state.networkAnalysisServiceRanges = v
    },
    setTotalSquareFootage(state, v) {
      state.totalSquareFootage = v
      this.dispatch('getNetworkAnalysisCosts')
      this.dispatch('getNetworkAnalysisServiceRanges')
    },
    serverRequestInProcess(state) {
      state.serverRequestInProcessSemaphore += 1
    },
    serverRequestComplete(state) {
      state.serverRequestInProcessSemaphore = state.serverRequestInProcessSemaphore < 0 ? 0 : state.serverRequestInProcessSemaphore - 1
    },
    setLeaseCostAdjuster(state, v) {
      state.inputAdjusters.leaseCostFactor = v
      this.dispatch('getNetworkAnalysisCosts')
    },
    setLaborCostAdjuster(state, v) {
      state.inputAdjusters.laborCostFactor = v
      this.dispatch('getNetworkAnalysisCosts')
    },
    setDistributionCenterCountAdjuster(state, v) {
      state.inputAdjusters.distributionCenterCountFactor = v
      this.dispatch('getNetworkAnalysisCosts')
    },
    setNetworkAnalysisBaseServiceRanges(state, v) {
      state.inputAdjusters.networkAnalysisBaseServiceRanges = v
    },
    setMarketToCustomerLinks(state, v) {
      state.marketToCustomerLinks = v
    },
    setMarketsToCompare(state, v) {
      state.marketsToCompare = v
    },
    setMarketCostComparison(state, v) {
      state.marketCostComparison = v
    },
    setCustomMarketGeocodedData(state, v) {
      state.customMarketGeocodedData = v
    },
    setFreightAssumptions(state, v) {
      state.assumptions.freight = v
      this.dispatch('getNetworkAnalysisCosts')
    },
    setInventoryAssumptions(state, v) {
      state.assumptions.inventory = v
      this.dispatch('getNetworkAnalysisCosts')
    },
    setLaborAssumptions(state, v) {
      state.assumptions.labor = v
      this.dispatch('getNetworkAnalysisCosts')
    },
    setLeaseAssumptions(state, v) {
      state.assumptions.lease = v
      this.dispatch('getNetworkAnalysisCosts')
    },
    setFreightAssumptionsToDefault(state) {
      this.commit('setFreightAssumptions', _.cloneDeep(state.defaults.assumptions.freight))
    },
    setInventoryAssumptionsToDefault(state) {
      this.commit('setInventoryAssumptions', _.cloneDeep(state.defaults.assumptions.inventory))
    },
    setLaborAssumptionsToDefault(state) {
      this.commit('setLaborAssumptions', _.cloneDeep(state.defaults.assumptions.labor))
    },
    setLeaseAssumptionsToDefault(state) {
      this.commit('setLeaseAssumptions', _.cloneDeep(state.defaults.assumptions.lease))
    },
    setBusinessValuesToDefault(state) {
      // This method essentially combines setMarkets, setAnnualRevenue, and setTotalSquareFootage
      //  since calling each of these individually to set them to default values ends up causing async issues
      //  because of repeated getNetworkAnalysisCosts/getNetworkAnalysisServiceRanges calls
      let marketIds = state.defaultMarkets[state.defaults.distributionCenterCount]
      let theMarkets = _.filter(state.availableMarkets, o => {
        return _.includes(marketIds, o.id)
      })
      
      state.markets = theMarkets
      this.commit('setDistributionCenterCount', state.defaults.distributionCenterCount)
      
      state.totalSquareFootage = state.defaults.totalSquareFootage
      state.annualRevenue = state.defaults.annualRevenue
      state.assumptions.labor.totalNetworkEmployees = state.defaults.assumptions.labor.totalNetworkEmployees

      if(state.assumptions.inventory.percentageLocked) {
        state.assumptions.inventory.totalHoldings = Number((state.annualRevenue * (state.assumptions.inventory.percentageOfRevenue / 100)).toFixed(0))
      }
      if(state.assumptions.freight.percentageLocked) {
        let inboundPercentOfTrans = 0.33333, outboundPercentOfTrans = 0.8666 - (0.05 * Math.pow(state.distributionCenterCount, 0.5))
        state.assumptions.freight.inboundCost  = Number((inboundPercentOfTrans * (state.annualRevenue * (state.assumptions.freight.percentageOfRevenue / 100))).toFixed(0))
        state.assumptions.freight.outboundCost = Number((outboundPercentOfTrans * (state.annualRevenue * (state.assumptions.freight.percentageOfRevenue / 100))).toFixed(0))
      }
      
      this.dispatch('getNetworkAnalysisCosts')
      this.dispatch('getNetworkAnalysisServiceRanges')
      this.dispatch('getMarketToCustomerLinks')
    },
    setBusinessValuesAndAssumptions(state, v){
      let theMarkets = _.filter(state.availableMarkets, o => {
        return _.includes(v.markets, o.name)
      })
      state.markets = theMarkets
      
      this.commit('setDistributionCenterCount', theMarkets.length)
      state.totalSquareFootage = v.businessValues.totalSquareFootage
      state.annualRevenue = v.businessValues.annualRevenue
      state.assumptions.labor.totalNetworkEmployees = v.businessValues.totalNetworkEmployees

      state.assumptions.freight.percentageLocked = false
      state.assumptions.freight.percentageOfRevenue = v.freightAssumptions.percentageOfRevenue
      state.assumptions.freight.inboundCost  = v.freightAssumptions.inboundCost
      state.assumptions.freight.outboundCost = v.freightAssumptions.outboundCost
      
      state.assumptions.inventory.percentageLocked = false
      state.assumptions.inventory.percentageOfRevenue = v.inventoryAssumptions.percentageOfRevenue
      state.assumptions.inventory.totalHoldings = v.inventoryAssumptions.totalHoldings
      state.assumptions.inventory.costOfCapital = v.inventoryAssumptions.costOfCapital
      state.assumptions.inventory.shrinkObsolescence = v.inventoryAssumptions.shrinkObsolescence
      
      state.assumptions.labor.hourlyRate = v.laborAssumptions.hourlyRate
      
      state.assumptions.lease.ratePerSqft = v.leaseAssumptions.ratePerSqft
      
      this.dispatch('getNetworkAnalysisCosts')
      this.dispatch('getNetworkAnalysisServiceRanges')
      this.dispatch('getMarketToCustomerLinks')
    },
    setSessionUsageData(state, v){
      state.sessionUsageData = v
    },
    setSessionId(state, v){
      state.sessionId = v
    },
    setIncompleteSessionSurveyShown(state, v){
      state.incompleteSessionSurveyShown = v
    }
  },

  actions: {
    getDefaultMarkets(context) {
      context.commit('serverRequestInProcess')

      apiServer
        .get(`/markets/defaults`)
        .then(resp => {
          context.commit('setDefaultMarkets', resp.data)

          let marketIds = resp.data[context.state.distributionCenterCount]
          let theMarkets = _.filter(context.state.availableMarkets, o => {
            return _.includes(marketIds, o.id)
          })
    
          context.commit('setMarkets', theMarkets)
          context.commit('serverRequestComplete')
        })
        .catch(err => {
          context.commit('setDefaultMarkets', [])
          context.commit('serverRequestComplete')
          console.log(err)
        })
    },
    getAvailableMarkets(context) {
      context.commit('setAvailableMarkets', [])
      context.commit('serverRequestInProcess')

      apiServer
        .get("/markets")
        .then(resp => {
          context.commit('setAvailableMarkets', resp.data)
          context.dispatch('getDefaultMarkets')
          context.dispatch('getMarketsToCompare')          
          context.commit('serverRequestComplete')
        })
        .catch(err => {
          context.commit('setAvailableMarkets', [])
          context.commit('serverRequestComplete')
          console.log(err)
        })
    },
    getCustomers(context) {
      context.commit('setCustomers', [])
      context.commit('serverRequestInProcess')

      apiServer
        .get("/customers")
        .then(resp => {
          context.commit('setCustomers', resp.data)
          context.commit('serverRequestComplete')
        })
        .catch(err => {
          context.commit('setCustomers', [])
          context.commit('serverRequestComplete')
          console.log(err)
        })
    },
    getNetworkAnalysisCosts(context) {
      context.commit('serverRequestInProcess')

      apiServer
        .post("/analysis/costs", {
          annualRevenue: context.getters.annualRevenue,
          squareFootage: context.getters.totalSquareFootage,
          markets: context.getters.markets,
          params: context.getters.assumptions
        })
        .then(resp => {
          context.commit('setNetworkAnalysisCosts', resp.data)
          context.commit('serverRequestComplete')
        })
        .catch(err => {
          context.commit('serverRequestComplete')
          console.log(err)
        })
    },
    getNetworkAnalysisServiceRanges(context) {
      context.commit('serverRequestInProcess')

      apiServer
        .post("/analysis/service", {
          annualRevenue: context.getters.annualRevenue,
          squareFootage: context.getters.totalSquareFootage,
          markets: context.getters.markets
        })
        .then(resp => {
          context.commit('setNetworkAnalysisServiceRanges', resp.data)
          context.commit('serverRequestComplete')
        })
        .catch(err => {
          context.commit('serverRequestComplete')
          console.log(err)
        })
    },
    getMarketToCustomerLinks(context) {
      context.commit('serverRequestInProcess')

      apiServer
        .post("/customers/service", context.getters.markets)
        .then(resp => {
          context.commit('setMarketToCustomerLinks', resp.data)
          context.commit('serverRequestComplete')
        })
        .catch(err => {
          context.commit('serverRequestComplete')
          console.log(err)
        })
    },

    getMarketsToCompare(context) {
      context.commit('setMarketsToCompare', [
//        { market: context.getters.availableMarkets[0], totalCost: undefined, realEstateCost: undefined, laborCost: undefined, transportationCost: undefined }
      ])
    },

    getMarketComparisonData(context, marketsToCompare) {
      context.commit('serverRequestInProcess')

      if(marketsToCompare.length) {
        apiServer
          .post("/analysis/costscomparison", {
            annualRevenue: 0,
            squareFootage: 0,
            markets: marketsToCompare
          })
          .then(resp => {
            context.commit('setMarketCostComparison', resp.data)
            context.commit('serverRequestComplete')
          })
          .catch(err => {
            context.commit('serverRequestComplete')
            console.log(err)
          })
      } else {
        context.commit('setMarketCostComparison', [])
        context.commit('serverRequestComplete')
      }
    },
    
    getNetworkCostsComparisonFromFile(context, importFile){
      let formData = new FormData()
      formData.append('file', importFile)
      
      return apiServer
        .post("/analysis/costscomparison/fromFile", formData, { headers: {'Content-Type': 'multipart/form-data'} })
        .then(resp => {
          return resp.data
        })
    },
    getNetworkAnalysisAssumptionsFromFile(context, importFile){
      let formData = new FormData()
      formData.append('file', importFile)
      
      return apiServer
        .post("/analysis/assumptions/fromFile", formData, { headers: {'Content-Type': 'multipart/form-data'} })
        .then(resp => {
          return resp.data
        })
    },
    geocodeLocation(context, locationString) {
      context.commit('serverRequestInProcess')
      
      if(locationString && locationString.length){
        return apiServer
          .post("utils/geocode", locationString, { headers: { 'Content-Type': 'text/plain'} })
          .then(resp => {
            context.commit('setCustomMarketGeocodedData', resp.data)
            context.commit('serverRequestComplete')
            return resp.data
          })
      } else {
        context.commit('setCustomMarketGeocodedData', {})
        context.commit('serverRequestComplete')
        return Promise.resolve({})
      }
    },
    calculateCostPerContainerAtNearestPort(context, latLng) {
      context.commit('serverRequestInProcess')
      
        if(latLng && (latLng.latitude || latLng.latitude == 0) && (latLng.longitude || latLng.longitude == 0)){
          return apiServer
            .post("utils/costPerContainerAtNearestPort", latLng)
            .then(resp => {
              context.commit('serverRequestComplete')
              return resp.data
            })
        } else {
          context.commit('serverRequestComplete')
          return Promise.resolve(0)
        }
    },
    findCheapestMarkets(context, numMarketsToFind) {
      if(numMarketsToFind){
        return apiServer
          .post("analysis/findcheapestmarkets", {numMarketsToFind: numMarketsToFind, markets: context.getters.markets})
          .then(resp => {
            if(resp.data){
              let theMarkets = resp.data.map(mId => {
                return context.getters.availableMarkets.find(m => m.id === mId)
              })
              context.commit('setMarkets', theMarkets)
            }
          })
      } else {
        return Promise.reject()
      }
    },
    findHighestDemandMarkets(context, numMarketsToFilterOut) {
      if(numMarketsToFilterOut){
        if(numMarketsToFilterOut >= context.getters.markets.length){
          numMarketsToFilterOut = context.getters.markets.length - 1
        }
        return apiServer
          .post("analysis/findhighestdemandmarkets", {numMarketsToFilterOut: numMarketsToFilterOut, markets: context.getters.markets})
          .then(resp => {
            if(resp.data){
              let theMarkets = resp.data.map(mId => {
                return context.getters.availableMarkets.find(m => m.id === mId)
              })
              context.commit('setMarkets', theMarkets)
            }
          })
      } else {
        return Promise.reject()
      }
    },
    findAverageLeaseRate(context) {
      let leaseAverage = 0
      let leaseAssumptions = context.getters.leaseAssumptions
      let theMarkets = context.getters.markets
      theMarkets.forEach(m => {
        leaseAverage += m.leaseRate
      })
      leaseAverage = ((leaseAverage / theMarkets.length) || 0).toFixed(4)
      leaseAssumptions.ratePerSqft = leaseAverage
      context.commit('setLeaseAssumptions', leaseAssumptions)
    },
    findAverageLaborRate(context) {
      let laborAverage = 0
      let laborAssumptions = context.getters.laborAssumptions
      let theMarkets = context.getters.markets
      theMarkets.forEach(m => {
        laborAverage += m.laborRate
      })
      laborAverage = ((laborAverage / theMarkets.length) || 0).toFixed(2)
      laborAssumptions.hourlyRate = laborAverage
      context.commit('setLaborAssumptions', laborAssumptions)
    },
    checkHasIncompleteSession(context) {
      let lastIncompleteSession = Vue.prototype.$cookies.get('lastIncompleteSession')
      if(lastIncompleteSession && lastIncompleteSession.surveyStatus == "incomplete" && lastIncompleteSession.sessionId != context.getters.sessionId){
        return Promise.resolve(true)
      } else { 
        return Promise.resolve(false)
      }
    },
    markSessionComplete(context) {
      let lastSession = Vue.prototype.$cookies.get('lastSession')
      if(lastSession.sessionId == context.getters.sessionId){
        Vue.prototype.$cookies.set('lastSession', {
          sessionId: context.getters.sessionId,
          surveyStatus: 'complete',
          sessionStartTime: lastSession.sessionStartTime
        }, "3m")
      }
    },
    initializeSessionDetails(context) {
      let initSessionStartTime = new Date()
      let cSessionId = Vue.prototype.$cookies.get('sessionId')
      if(!cSessionId){
        context.commit('setSessionId', uuid.v4())
      } else {
        context.commit('setSessionId', cSessionId)
      }
      Vue.prototype.$cookies.set('sessionId', context.getters.sessionId)
      
      let lastSession = Vue.prototype.$cookies.get('lastSession')
      if(lastSession && lastSession.sessionId != context.getters.sessionId){
        if(lastSession.surveyStatus == "incomplete"){
          Vue.prototype.$cookies.set('lastIncompleteSession', lastSession, "3m")
        } 
        Vue.prototype.$cookies.set('lastSession', {
          sessionId: context.getters.sessionId,
          surveyStatus: 'incomplete',
          sessionStartTime: initSessionStartTime
        }, "3m")
      } else if(!lastSession){
        Vue.prototype.$cookies.set('lastSession', {
          sessionId: context.getters.sessionId,
          surveyStatus: 'incomplete',
          sessionStartTime: initSessionStartTime
        }, "3m")
      }
      
      let initStatus = Vue.prototype.$cookies.get('sessionInitStatus')
      if(initStatus && (initStatus == "inProgress" || initStatus == "done")) {
        return Promise.resolve()
      } else {
        Vue.prototype.$cookies.set("sessionInitStatus", "inProgress", "2min")
      }
      
      let userPromise = Vue.prototype.$auth.getUser()
        .then(user => {
          context.state.accessingUserInfo.userSub = user.sub
          context.state.accessingUserInfo.userEmail = user.email || ""
          context.state.accessingUserInfo.userName = user.name || (user.family_name || user.given_name || "")
        })

      let ipPromise = Vue.axios.get('http://ip-api.com/json')
        .then(resp => {
          if(resp && resp.data && resp.data.query){
            context.state.accessingUserInfo.userIp = resp.data.query
          }
        })
        .catch((err) => {
          console.log('Req err -',err)
          return
        })

      let nUserAgent = navigator.userAgent
      let nPlatform = navigator.platform

      // https://developer.mozilla.org/en-US/docs/Web/API/Window/navigator
      if (nUserAgent.indexOf("Firefox") > -1) {
        context.state.accessingUserInfo.userBrowser = "Firefox"
      } else if (nUserAgent.indexOf("Opera") > -1 || nUserAgent.indexOf("OPR") > -1) {
        context.state.accessingUserInfo.userBrowser = "Opera"
      } else if (nUserAgent.indexOf("Trident") > -1) {
        context.state.accessingUserInfo.userBrowser = "IE"
      } else if (nUserAgent.indexOf("Edge") > -1) {
        context.state.accessingUserInfo.userBrowser = "Edge"
      } else if (nUserAgent.indexOf("Chrome") > -1) {
        context.state.accessingUserInfo.userBrowser = "Chrome/Chromium"
      } else if (nUserAgent.indexOf("Safari") > -1) {
        context.state.accessingUserInfo.userBrowser = "Safari"
      } else {
        context.state.accessingUserInfo.userBrowser = "unknown"
      }

      if(nPlatform.indexOf("Win") > -1) {
        context.state.accessingUserInfo.userOs = "Windows"
      } else if(nPlatform.indexOf("Mac") > -1) {
        context.state.accessingUserInfo.userOs = "MacOS"
      } else if(nPlatform.indexOf("X11") > -1) {
        context.state.accessingUserInfo.userOs = "UNIX"
      } else if(nPlatform.indexOf("Linux") > -1) {
        context.state.accessingUserInfo.userOs = "Linux"
      } else if(nPlatform.indexOf("iPhone") > -1) {
        context.state.accessingUserInfo.userOs = "iOS"
      } else if(nPlatform.indexOf("Android") > -1) {
        context.state.accessingUserInfo.userOs = "Android"
      } else {
        context.state.accessingUserInfo.userOs = "unknown"
      }
      
      return Promise.all([userPromise, ipPromise])
        .then(() => {
          let initSessionDetails = _.cloneDeep(context.getters.accessingUserInfo)
          initSessionDetails.sessionId = context.getters.sessionId
          initSessionDetails.startTime = initSessionStartTime.toISOString().slice(0, 19).replace('T', ' ')
          return apiServer
            .post("stats/initializesessiondetails", initSessionDetails)
            .then(resp => {
              Vue.prototype.$cookies.set("sessionInitStatus", "done")
              return resp.data
            })
        })
        .catch((err) => {
          console.log(err)
          Vue.prototype.$cookies.remove("sessionInitStatus")
        })
    },
    updateSessionEndTime(context) {
      apiServer
        .post("stats/updatesessiondetails", {
          sessionId: context.getters.sessionId,
          endTime: new Date().toISOString().slice(0, 19).replace('T', ' ')
        })
        .then(resp => {
          return resp.data
        })
    },
    updateSessionAppUsed(context, appUsed) {
      apiServer
        .post("stats/updatesessiondetails", {
          sessionId: context.getters.sessionId,
          appUsed: appUsed
        })
        .then(resp => {
          return resp.data
        })
    },
    updateSessionUsageData(context, usageData) {
      apiServer
        .post("stats/updatesessiondetails", {
          sessionId: usageData.sessionId || context.getters.sessionId,
          customerName: usageData.customerName,
          score: usageData.score,
          usePurpose: usageData.usePurpose,
          comments: usageData.comments || ""
        })
        .then(resp => {
          return resp.data
        })
    },
    refreshSessionTokens(context) {
      Vue.prototype.$cookies.set("sessionInitStatus", "done")
      Vue.prototype.$cookies.set('sessionId', context.getters.sessionId)
    },
    closeSession(context) {
      Vue.prototype.$cookies.remove("sessionInitStatus")
      Vue.prototype.$cookies.remove("sessionId")
    },
    findSessions(context, filter) {
      return apiServer
        .post("stats/findsessions", filter)
        .then(resp => {
          return resp.data
        })
    },

    init(context) {
      /* context.dispatch('getAvailableMarkets')
      context.dispatch('getCustomers')
      context.dispatch('initializeSessionDetails') */
    },

  },

  getters: {
    apiServer: state => {
      return state.apiServer
    },
    serverRequestInProcess: state => {
      return state.serverRequestInProcessSemaphore > 0
    },
    sessionId: state => {
      return state.sessionId
    },
    accessingUserInfo: state => {
      return state.accessingUserInfo
    },
    availableMarkets: state => {
      return state.availableMarkets
    },
    marketParams: state => {
      return state.marketParams
    },
    customMarkets: state => {
      return state.customMarkets
    },
    defaultMarkets: state => {
      return state.defaultMarkets
    },
    customMarketGeocodedData: state => {
      return state.customMarketGeocodedData
    },
    naMarketManuallySpecified: state => {
      return state.naMarketManuallySpecified
    },
    customers: state => {
      return state.customers
    },
    markets: state => {
      return state.markets
    },
    annualRevenue: state => {
      return state.annualRevenue
    },
    distributionCenterCount: state => {
      return state.distributionCenterCount
    },
    totalSquareFootage: state => {
      return state.totalSquareFootage
    },
    networkAnalysisCosts: state => {
      return state.networkAnalysisCosts
    },
    networkAnalysisServiceRanges: state => {
      return state.networkAnalysisServiceRanges
    },
    marketToCustomerLinks: state => {
      return state.marketToCustomerLinks
    },
    marketsToCompare: state => {
      return state.marketsToCompare
    },
    marketCostComparison: state => {
      return state.marketCostComparison
    },
    whatIfLeaseFactor: state => {
      return state.inputAdjusters.leaseCostFactor
    },
    whatIfLaborFactor: state => {
      return state.inputAdjusters.laborCostFactor
    },
    whatIfDistributionCenterFactor: state => {
      return state.inputAdjusters.distributionCenterCountFactor
    },
    networkAnalysisBaseServiceRanges: state => {
      return state.inputAdjusters.networkAnalysisBaseServiceRanges
    },
    assumptions: state => {
      return state.assumptions
    },
    freightAssumptions: state => {
      return state.assumptions.freight
    },
    inventoryAssumptions: state => {
      return state.assumptions.inventory
    },
    laborAssumptions: state => {
      return state.assumptions.labor
    },
    leaseAssumptions: state => {
      return state.assumptions.lease
    },
    sessionUsageData: state => {
      return state.sessionUsageData
    },
    incompleteSessionSurveyShown: state => {
      return state.incompleteSessionSurveyShown
    },
    pdfMapStyleParams: state => {
      return state.pdfMapStyleParams
    }

  }
})
